module.exports = __webpack_public_path__ + "img/arrow_right.474819be.png";